var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Spin } from 'antd';
import * as React from 'react';
import { Link } from 'react-router-dom';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement("div", { className: "page-header page-header-light" },
                React.createElement("div", { className: "page-header-content header-elements-md-inline" },
                    React.createElement("div", { className: "page-title d-flex" },
                        React.createElement("h4", null, this.props.title),
                        React.createElement("a", { href: "#", className: "header-elements-toggle text-default d-md-none" },
                            React.createElement("i", { className: "icon-more" }))),
                    React.createElement("div", { className: "header-elements d-none page-actions" }, this.props.buttons)),
                React.createElement("div", { className: "breadcrumb-line breadcrumb-line-light header-elements-md-inline" },
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("div", { className: "breadcrumb" },
                            React.createElement(Link, { className: "breadcrumb-item", to: "/" },
                                React.createElement("i", { className: "icon-home2 mr-2" })),
                            React.createElement(Link, { className: "breadcrumb-item", to: "/" }, "Anasayfa"),
                            this.props.breadcrumbs &&
                                this.props.breadcrumbs.map(function (br) {
                                    return br.link ? (React.createElement(Link, { key: Math.random(), className: "breadcrumb-item", to: br.link }, br.text)) : (React.createElement("span", { className: "breadcrumb-item active" }, br.text));
                                })),
                        React.createElement("a", { href: "#", className: "header-elements-toggle text-default d-md-none" },
                            React.createElement("i", { className: "icon-more" }))))),
            React.createElement("div", { className: "content" },
                React.createElement(Spin, { spinning: this.props.loading },
                    React.createElement("div", { className: "card" }, this.props.children)))));
    };
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/shared/layout/Page.tsx
// module id = 47
// module chunks = 0